

export function executeGet<T>(path: string, customHeaders?: object): Promise<T> {

    let headers = { ...customHeaders , 'Content-Type': 'application/json'};
    return new Promise((resolve, reject) => {
        fetch(path, {
            method: 'get',
            headers: headers
        })
            .then(response => {
                if (response.status === 401 || response.status === 403) {
                    reject("Unauthorised");
                }
                else if (response.status < 200 || response.status >= 300) {
                    var message = "Error processing request : status = " + response.status;
                    if (response.statusText) {
                        message += ", message = " + response.statusText;
                    }
                    reject(message);
                }
                else {
                    resolve(response.json() as Promise<T>);
                }           
            })
            .catch(error => {
                reject(error);
            });
    })
}


export function executePost<T>(request: any, path: string, customHeaders?: object): Promise<T> {

    let headers = { ...customHeaders, 'Content-Type': 'application/json' };
    return new Promise((resolve, reject) => {
        fetch(path, {
            method: 'post',
            headers: headers,
            body: JSON.stringify(request)
        })
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    var message = "Error processing request : status = " + response.status;
                    if (response.statusText) {
                        message += ", message = " + response.statusText;
                    }
                    reject(message);
                }
                else {
                    resolve(response.json() as Promise<T>);
                }
            })
            .catch(error => {
                reject(error);
            });
    })
}
